const styles = (theme) => ({
  root: {
    lineHeight: 1,
    marginRight: 12,
  },
  icon: {
    width: '0.8rem',
  },
});

export default styles;
